import { render } from "./DirectorFacultyCourseLoadingDialog.vue?vue&type=template&id=02803ee1"
import script from "./DirectorFacultyCourseLoadingDialog.vue?vue&type=script&lang=js"
export * from "./DirectorFacultyCourseLoadingDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__